import { render, staticRenderFns } from "./BulkFlagUpdate.vue?vue&type=template&id=ecad0284&scoped=true&"
import script from "./BulkFlagUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkFlagUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecad0284",
  null
  
)

export default component.exports